import http from "./httpService";
import {
  EVENT_COLLECT_PROVIDER_KEY,
  EVENT_COLLECT_PROVIDER_VALUE,
  EVENT_COLLECT_TOKEN_KEY,
  EVENT_COLLECT_USER_ID_KEY,
  EVENT_COLLECT_USER_KEY,
  EVENT_MONITORING_PROVIDER_KEY,
  EVENT_MONITORING_TOKEN_KEY,
  EVENT_MONITORING_USER_ID_KEY,
  EVENT_MONITORING_USER_KEY,
} from "../utils/constants";

export const apiEndpoint = process.env.REACT_APP_API_URL + "/login";

http.setJwt(getJwt()!);

export const login = async (email: string, password: string) => {
  const { data } = await http.post(apiEndpoint, { email, password });
  const jwt = data.data.token;
  localStorage.setItem(
    EVENT_COLLECT_PROVIDER_KEY,
    EVENT_COLLECT_PROVIDER_VALUE
  );
  localStorage.setItem(EVENT_COLLECT_TOKEN_KEY, jwt);
  localStorage.setItem(EVENT_COLLECT_USER_KEY, data.data.findUser.email);
  localStorage.setItem(EVENT_COLLECT_USER_ID_KEY, data.data.findUser._id);
  return data;
};

export function loginWithJwt(jwt: string | number | boolean) {
  localStorage.setItem(EVENT_COLLECT_TOKEN_KEY, jwt.toString());
}

export function logout() {
  localStorage.removeItem(EVENT_COLLECT_PROVIDER_KEY);
  localStorage.removeItem(EVENT_COLLECT_TOKEN_KEY);
  localStorage.removeItem(EVENT_COLLECT_USER_KEY);
  localStorage.removeItem(EVENT_COLLECT_USER_ID_KEY);
}

export function monitoringLogout() {
  localStorage.removeItem(EVENT_MONITORING_PROVIDER_KEY);
  localStorage.removeItem(EVENT_MONITORING_TOKEN_KEY);
  localStorage.removeItem(EVENT_MONITORING_USER_KEY);
  localStorage.removeItem(EVENT_MONITORING_USER_ID_KEY);
}

export function getRolesFromJwt() {
  const token = getMonitoringJwt() || "";

  // Split the JWT into its parts (header, payload, signature)
  const parts = token.split(".");

  if (parts.length !== 3) {
    throw new Error("Invalid JWT token");
  }

  // Decode the payload (second part) from base64
  const payload = JSON.parse(atob(parts[1]));

  // Extract and return the roles field
  return payload.roles || [];
}

export const permit = (allowedRoles: string | string[] = []) => {
  // Normalize the roles to lowercase for case-insensitive comparison
  const userRoles: string[] = getRolesFromJwt();
  const rolesArray = Array.isArray(allowedRoles)
    ? allowedRoles.map((role) => role.toLowerCase())
    : [allowedRoles.toLowerCase()];

  const userRoleNames = userRoles.map((role) =>
    role.split("_")[1].toLowerCase()
  );

  // Check if user has one of the allowed roles
  return userRoleNames.some((roleName) => rolesArray.includes(roleName));
};

export function getJwt() {
  return localStorage.getItem(EVENT_COLLECT_TOKEN_KEY);
}

export function getMonitoringJwt() {
  return localStorage.getItem(EVENT_MONITORING_TOKEN_KEY);
}

export function getCurrentUser() {
  return localStorage.getItem(EVENT_COLLECT_USER_KEY);
}

export function getUserId() {
  return localStorage.getItem(EVENT_COLLECT_USER_KEY);
}

export function getMonitoringCurrentUser() {
  return localStorage.getItem(EVENT_MONITORING_USER_KEY);
}

export function getMonitoringUserId() {
  return localStorage.getItem(EVENT_MONITORING_USER_ID_KEY);
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  login,
  loginWithJwt,
  logout,
  getJwt,
  getUserId,
};
